export const MESSAGES = {
  CHECKOUT_API: "Checkout API",
  CREDIT_CARD: "Credit Card",
  REFUNDED: "Refunded",
};
